/* eslint-disable react/require-default-props */
import React from 'react';

const ButtonUI = (props) => {
    const onConfirm = (e) => {
        e.currentTarget.blur();
        if (props.onClick) {
            props.onClick();
        }
    };

    const largeButton = () => {
        if (props.large) {
            return 'btn-large'
        }
        return ''
    }

    return (
        <button
            {...props}
            onClick={(e) => onConfirm(e)}
            type="button"
            style={{ borderRadius: '5px' }}
            className={props?.secundary ? `col ${props.full ? 's12' : 's6'} btn ${largeButton()} waves-effect waves-light btn-gray` : `col ${props.full ? 's12' : 's6'} btn ${largeButton()} btn-principal waves-effect  waves-light`}
        >
            {props.text}
            {props?.icon && (<i className="material-icons right">{props?.icon}</i>)}
        </button>
    );
};

export default ButtonUI;
